import React from 'react';
import Dialog from '@material-ui/core/Dialog';

const ModalView = ({ openEdit, setOpenEdit, children }) => {
  return (
    <Dialog
      onClose={(e) => setOpenEdit(false, e)}
      aria-labelledby="customized-dialog-title"
      open={openEdit}
    >
      {children}
    </Dialog>
  );
};

export default ModalView;
